import { RecognisedHeaderLabels } from 'common/enums/known-data-enums.js';
import { QuantitiesTypes, defaultUnits } from 'common/enums/unit-templates.js';
import { KnowEdmTableData } from './table-enums.js';

const porePressureMap = new Map();

porePressureMap.set(KnowEdmTableData.Tvd, {
  key: KnowEdmTableData.Tvd,
  label: RecognisedHeaderLabels.DepthTVD,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
});

porePressureMap.set(KnowEdmTableData.PorePressureGradient, {
  key: KnowEdmTableData.PorePressureGradient,
  label: RecognisedHeaderLabels.PorePressureGradient,
  unit: defaultUnits.get(QuantitiesTypes.Density),
  quantity: QuantitiesTypes.Density,
});

porePressureMap.set(KnowEdmTableData.PorePressure, {
  key: KnowEdmTableData.PorePressure,
  label: RecognisedHeaderLabels.PorePressure,
  unit: defaultUnits.get(QuantitiesTypes.PressureСhange),
  quantity: QuantitiesTypes.PressureСhange,
});

export {
  porePressureMap,
};
